<template>
  <div>
    <div class="highlight--stats" :style="{ 'background-color': bg_color }">
      <div class="row">
        <div class="col-8">
          <span class="stats--title mb-2">
            {{ title }}
            <i class="fal fa-info-circle" :id="id"></i>
            <b-popover :target="id" triggers="hover" placement="top">
              <!-- <template #title>{{ title }}</template> -->
              {{ description }}
            </b-popover>
          </span>
          <div class="value--unit">
            <span class="stats--value">
              {{ value == null || isNaN(value) ? "Loading..." : numberWithCommas(value) }}
            </span>
          </div>
        </div>
        <!-- <div class="col-4" style="display: flex; align-items: center; justify-content: center">
          <i class="fas fa-4x" :class="icon"></i>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["id", "title", "value", "icon", "bg_color", "description"],
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.highlight--stats {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 30px 20px;

  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;

  /* box-shadow: 0 0 5px rgb(173, 173, 173); */
}

.value--unit {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-items: flex-end;
}

.stats--title {
  font-size: 18px;
  font-weight: 500;
  color: white;
  color: #9f9f9f;
}

.stats--value {
  font-size: 40px;
  font-weight: bold;
  color: white;
  color: #545454;
}

.stats--unit {
  font-size: 14px;
  font-weight: 500;
  /* color: white; */
  color: #d1d1d1;
  padding: 0 0 10px 10px;
}

.fas {
  color: rgba(0, 0, 0, 0.15);
}
</style>
